import { ReactNode, FC } from "react";

import Button from "../../../components/Mobile/Button";

const ResourceHow = () => {
  return (
    <section className="relative z-0 mb-[48px] h-[1490px] sm:h-[1300px]">
      <div className="relative w-full h-full">
        {/* First Row */}
        <div
          className="h-[174px] bg-primaryDark-400 scroll-mt-[90px] pt-[40px]"
          id="resource-how"
        >
          <h4 className="text-[24px] text-text-1000 text-center font-raleway font-bold ">
            How Does It Work?
          </h4>
        </div>

        {/* Second Row */}
        <div className="bg-text-1000 border border-[#E9E9E9] rounded-[16px] absolute z-[2] top-[120px] right-[20px] left-[20px] px-[25px] py-[20px]">
          {/* Cards */}
          <div className="grid grid-cols-1 gap-[24px] mb-[24px]">
            {/* Card One */}
            <ResourceHowCard
              step={1}
              heading={<>Complete Your Profile</>}
              description="Sign up with HomeCook and showcase your unique offerings and charm."
            />

            {/* Card Two */}
            <ResourceHowCard
              step={2}
              heading={<>Preview Booking Requests</>}
              description="Receive booking requests from pre-vetted food entrepreneurs. "
            />

            {/* Card Three */}
            <ResourceHowCard
              step={3}
              heading={<>Control Your Availability</>}
              description="Tailor open calendar slots based on your availability."
            />

            {/* Card Four */}
            <ResourceHowCard
              step={4}
              heading={<>Coordinate with Clients</>}
              description="Directly communicate through HomeCook to coordinate logistics."
            />

            {/* Card Five */}
            <ResourceHowCard
              step={5}
              heading={<>Track Usage and Payments</>}
              description="Manage bookings & receive payments all in real-time through our app. "
            />
          </div>

          {/* Button */}
          <div className="scroll-mt-[100px]" id="resource-how-box">
            <Button
              label="Watch Tutorials"
              variant="secondary"
              onClick={() => window.open("https://site.homecookapp.com/kitchen-dashboard-step-categories", "_blank")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

type ResourceHowCardProps = {
  step: number;
  heading: ReactNode;
  description: string;
};

const ResourceHowCard: FC<ResourceHowCardProps> = ({
  step,
  heading,
  description,
}) => {
  return (
    <div className="border-[2px] border-dashed border-[#E9E9E9] rounded-[16px] p-[20px]">
      {/* Header */}
      <div className="flex items-center gap-[16px] mb-[16px]">
        <p className="text-[80px] font-raleway text-[#F5F5F5] leading-none">
          {step}
        </p>
        <h5 className="text-[20px] font-raleway font-semibold text-primaryDark-0 leading-tight">
          {heading}
        </h5>
      </div>

      <p className="text-[16px] font-open-sans text-text-0 leading-loose">
        {description}
      </p>
    </div>
  );
};

export default ResourceHow;
